import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Account.scss';

import { hasZoomConnected, hasHubspotConnected, getEmail } from '../helpers/user_helpers';
import { ZOOM_CLIENT_ID, HUBSPOT_CLIENT_ID } from '../helpers/constants';
import { getUrlParameter } from '../helpers/formatting';

class AccountView extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    connectZoomAccount: PropTypes.func.isRequired,
    connectHubspotAccount: PropTypes.func.isRequired,
    logoutUser: PropTypes.func.isRequired,
  };

  componentDidMount() {
    /*
      The zoom request returns a code query parameter.
    */
    const type = getUrlParameter('type');
    const code = getUrlParameter('code');
    if (type === 'zoom') {
      this.props.connectZoomAccount(code);
    } else if (type === 'hubspot') {
      this.props.connectHubspotAccount(code);
    }
    window.__ADD_EVENT__('Account - Page View');
  }

  getRedirectUriFromType = (type) =>
    process.env.REACT_APP_NODE_ENV === 'development' && type === 'zoom'
      ? `https://app.chipbrain.com/account?type=${type}` // since localhost isn't accepted by zoom
      : `${window.location.href}${window.location.href.includes('?') ? '&' : '?'}type=${type}`;

  requestZoomCredentials = () => {
    const redirect = this.getRedirectUriFromType('zoom');
    window.location.href = `https://zoom.us/oauth/authorize?response_type=code&client_id=${ZOOM_CLIENT_ID}&redirect_uri=${redirect}`;
  };

  requestHubspotCredentials = () => {
    const redirect = this.getRedirectUriFromType('hubspot');
    const scopes = [
      'crm.objects.contacts.write',
      'crm.objects.contacts.read',
      'crm.objects.deals.write',
      'crm.objects.companies.write',
      'crm.objects.companies.read',
      'crm.objects.deals.read',
      'crm.schemas.companies.read',
      'crm.schemas.companies.write',
      'crm.schemas.deals.read',
      'crm.schemas.contacts.read',
      'crm.schemas.contacts.write',
      'crm.schemas.deals.write',
      'crm.objects.owners.read',
    ];
    window.location.href = `https://app.hubspot.com/oauth/authorize?scope=${scopes.join(
      '%20'
    )}&client_id=${HUBSPOT_CLIENT_ID}&redirect_uri=${redirect}`;
  };

  render() {
    const { logoutUser, user } = this.props;
    return (
      <div className='account-view-outer-container'>
        <div className='account-view-inner-container'>
          {window.__ALLOW_DEALS__ && (
            <div className='section'>
              <div className='section-header-container'>
                <div className='section-header'>Connect HubSpot Account</div>
              </div>
              {hasHubspotConnected(user) ? (
                <div className='zoom-connect-btn connected'>HubSpot Account Connected</div>
              ) : (
                <div onClick={this.requestHubspotCredentials} className='hubspot-connect-btn'>
                  Connect My Account
                </div>
              )}
            </div>
          )}
          <div className='section'>
            <div className='section-header-container'>
              <div className='section-header'>Connect Zoom Account</div>
              {!hasZoomConnected(user) && (
                <div className='section-subheader'>
                  For instructions see{' '}
                  <a href='https://chipbrain.com/zoom-installation' target='_blank' rel='noopener noreferrer'>
                    here
                  </a>
                  .
                </div>
              )}
            </div>
            {hasZoomConnected(user) ? (
              <div className='zoom-connect-btn connected'>Zoom Account Connected</div>
            ) : (
              <div onClick={this.requestZoomCredentials} className='zoom-connect-btn'>
                Connect My Account
              </div>
            )}
          </div>
          <div className='section'>
            <div className='section-header-container'>
              <div className='section-header'>Log Out</div>
              <div className='section-subheader'>You are currently logged in as {getEmail(user)}</div>
            </div>
            <div onClick={logoutUser} className='zoom-connect-btn'>
              Log Out
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountView;
